import React from "react";
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Typography,
  IconButton,
  TextField,
  Button,
  Stack,
  Divider,
  Tooltip,
  Paper,
} from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import DragIndicatorRoundedIcon from "@mui/icons-material/DragIndicatorRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";

export default function IncludedSection({
  formData,
  setArrayItem,
  addArrayItem,
  removeArrayItem,
  handleText,
}) {
  const { t } = useTranslation("products");
  const itens = Array.isArray(formData.inclusos_itens) ? formData.inclusos_itens : [];

  const onAdd = () => addArrayItem("inclusos_itens", "");
  const onChange = (i: number, v: string) => setArrayItem("inclusos_itens", i, v);
  const onRemove = (i: number) => removeArrayItem("inclusos_itens", i);

  // Reordenação simples: clique sobe 1; duplo clique desce 1
  const move = (from: number, dir: number) => {
    const to = from + dir;
    if (to < 0 || to >= itens.length) return;
    const arr = [...itens];
    const [x] = arr.splice(from, 1);
    arr.splice(to, 0, x);
    arr.forEach((val, idx) => setArrayItem("inclusos_itens", idx, val));
  };

  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardHeader
        title={t("form.includedTitle")}
        action={
          <Tooltip title={t("form.includedTooltip")}>
            <InfoOutlinedIcon sx={{ fontSize: 20, color: "text.secondary" }} />
          </Tooltip>
        }
        sx={{ pb: 0.5, "& .MuiCardHeader-title": { fontSize: 16, fontWeight: 600 } }}
      />
      <CardContent sx={{ pt: 2 }}>
        <Stack spacing={1.5}>
          {itens.map((val: string, i: number) => (
            <Paper
              key={i}
              variant="outlined"
              sx={{
                p: 1,
                display: "flex",
                alignItems: "center",
                gap: 1,
                bgcolor: "background.paper",
              }}
            >
              <DragIndicatorRoundedIcon
                fontSize="small"
                sx={{ color: "text.disabled", cursor: "ns-resize" }}
                onClick={() => move(i, -1)}
                onDoubleClick={() => move(i, 1)}
              />
              <TextField
                fullWidth
                size="small"
                placeholder={t("form.includedItemPlaceholder")}
                value={val}
                onChange={(e) => onChange(i, e.target.value)}
              />
              <IconButton aria-label={t("form.removeAria")} onClick={() => onRemove(i)}>
                <DeleteOutlineRoundedIcon />
              </IconButton>
            </Paper>
          ))}

          <Box>
            <Button variant="outlined" startIcon={<AddRoundedIcon />} onClick={onAdd}>
              {t("form.includedAddItem")}
            </Button>
          </Box>

          <Divider sx={{ my: 1 }} />

          <Typography variant="subtitle2" fontWeight={700}>
            {t("form.includedExpertTip")}
          </Typography>
          <TextField
            multiline
            minRows={3}
            placeholder={t("form.includedExpertPlaceholder")}
            name="inclusos_dica"
            value={formData.inclusos_dica || ""}
            onChange={handleText}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}
